import { render, staticRenderFns } from "./Createpaper.vue?vue&type=template&id=1b9ec3ac&scoped=true"
import script from "./Createpaper.vue?vue&type=script&lang=js"
export * from "./Createpaper.vue?vue&type=script&lang=js"
import style0 from "./Createpaper.vue?vue&type=style&index=0&id=1b9ec3ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ec3ac",
  null
  
)

export default component.exports